import React from "react"
import autobind from "class-autobind"
import numeral from "numeral"

declare global {
    interface Window {
        Intercom: any
    }
}
interface IProps {
    yearlyLaborCosts: number,
    optimizationSavings: number,
    productivitySavings: number,
    administrativeSavings: number,
}

interface IState {
}

const subTitleClass = {
    textTransform: "uppercase",
    fontSize: "14pt",
    textAlign: "center",
    weight: "bold",
}

const titleClass = {
    fontSize: "45pt",
    lineHeight: "1em",
    textAlign: "center",
    minWidth: "350px",
}

const dataSectionClass = {
    borderBottom: "1px #efefef solid",
    paddingBottom: 20,
    paddingTop: 40,
}

const optimizationSavingsStyles = {
    color: "#7E06A2",
}

const productivityStyles = {
    color: "#02B79C",
}

const administrativeStyles ={
    color: "#0398F5",
}

const containerStyle = {
    paddingRight: 20,
}

export default class LeftWaveData extends React.Component<IProps, IState> {    
    constructor(props) {
        super(props)

        this.state = {
        }
        autobind(this)
    }

    render() {
        return (
            <div style={{...containerStyle}} >
                <div style={{...dataSectionClass}}>
                    <div style={{...subTitleClass}}>
                        estimated yearly labor cost
                    </div>
                    <div style={{...titleClass}}>
                        {numeral(this.props.yearlyLaborCosts).format('$0.0a')}
                    </div>                                        
                </div>
                <div style={{...dataSectionClass}}>
                    <div style={{...subTitleClass}}>
                        staff optimization savings
                    </div>
                    <div style={{...titleClass, ...optimizationSavingsStyles}}>
                        {numeral(this.props.optimizationSavings).format('$0.0a')}
                    </div>                                        
                </div>
                <div style={{...dataSectionClass}}>
                    <div style={{...subTitleClass}}>
                        productivity savings
                    </div>
                    <div style={{...titleClass, ...productivityStyles}}>
                        {numeral(this.props.productivitySavings).format('$0.0a')}
                    </div>                                        
                </div>
                <div style={{...dataSectionClass, paddingBottom: 17}}>
                   <div style={{...subTitleClass}}>
                        administrative savings
                    </div>
                    <div style={{...titleClass, ...administrativeStyles}}>
                        {numeral(this.props.administrativeSavings).format('$0.0a')}
                    </div>                                        
                </div>
            </div>
        )
    }
}